// extracted by mini-css-extract-plugin
export default {"istcontainer":"Ayurveda_istcontainer__oJt6U","featuredhbs":"Ayurveda_featuredhbs__zSA3U","Ashwagandha":"Ayurveda_Ashwagandha__LCI+S"};